import getLocale from '@utils/getLocale';

export const locale = getLocale();

const messages = {
  'fr-FR': {
    AGRICULTURAL_AREA: 'Votre surface agricole',
    AREA_TYPE: 'Type de surface',
    CULTIVATION_TYPE: 'Type de culture',
    CULTIVATION_SURFACE: 'Surface de votre culture (Ha)',
    PRECOCITY: 'Précocité',
    IRRIGATION: 'Irrigation',
    SUNFLOWER_TYPE: 'Type de tournesol',
    TEMPORARY_MEADOW: 'Prairie temporaire',
    FARMING_TYPE: "Type d'animaux",
    ANIMAL_COUNT: 'Nombre de têtes',
    ANNUAL_MILK_PRODUCTION: 'Production Laitière moyenne / vache / an',
    RATIONS: 'Profil ration',
    ADD_AREA: 'Ajouter une surface agricole utile',
    DELETE_AREA: 'Supprimer',
    CULTIVATION: 'Culture',
    FARMING: 'Elevage',
    CORN: 'Maïs Grain',
    CORN_FORAGE: 'Maïs Ensilage',
    RAPESEED: 'Colza',
    SUNFLOWER: 'Tournesol',
    SOFT_WHEAT: 'Blé Tendre',
    HARD_WHEAT: 'Blé dur',
    BARLEY: 'Orge',
    PEAS: 'Pois',
    FORAGE: 'Fourragère',
    ULTRA_VERY_EARLY: 'Ultra très précoce',
    VERY_EARLY: 'Très précoce',
    EARLY: 'Précoce',
    HALF_EARLY: 'Demi-précoce',
    HALF_LATE: 'Demi-tardif',
    LATE: 'Tardif',
    VERY_LATE: 'Très tardif',
    YES: 'Oui',
    NO: 'Non',
    OLEIQUE: 'Oléique',
    LINOLEIQUE: 'Linoléique',
    SUCKLER_CATTLE: 'Bovin allaitant',
    MILK_CATTLE: 'Bovin lait',
    CATTLE_FATTENING: 'Bovin engraissement',
    PORK: 'Porc',
    POULTRY: 'Volaille',
    SHEEP_GOAT: 'Ovins / Caprins',
    CORN_DOMINANT: 'Maïs Dominant',
    FORAGE_DOMINANT: 'Fourragères Dominant',
    MIXED: 'Mixte',
    MAX: 'max',
    ADD_VARIETY: 'Ajouter une variété',
    ADD_ANOTHER_VARIETY: 'Ajouter une autre variété',
    ADD_VARIETY_BY_CATEGORY:
      'Ajouter d’autres variétés de {CATEGORY_TITLE} pour les comparer',
    DOWNLOAD: 'Télécharger',
    DELETE: 'Supprimer',
    PRECOCITY_INDICE: 'Indice de précocité',
    STRENGTH: 'Points forts',
    FEATURES: 'Caractéristiques',
    GENETIC: 'Génétique',
    TECHNICAL_SHEETS: 'Fiche technique',
    VARIETY: 'Variété',
    MATURITY: 'Maturité',
    FILTER: 'Filtrer',
    MORE_SETTINGS: 'Plus de critères',
    PRINT: 'Imprimer',
    SHARE: 'Partager',
    SEND_TO_FRIEND: 'Envoyer à un ami',
    COPY: 'Copié !',
    INVESTMENT: 'Investissement supplémentaire pour la variété haut de gamme',
    FORAGE_AND_MILK_GAINS:
      'Gains en fourrage et en lait permis par rapport à la variété standard',
    GAIN_PER_DAIRY_COW_PER_YEAR: 'Gain par vache laitière et par an',
    GAIN_PER_1000_LITERS_MILK: 'Gain pour 1 000 litres de lait',
    RETURN_ON_INVESTMENT: 'Retour sur investissement',
    BUDGET_VARIETY_B_SEEDS: 'Coût des semences de la variété standard',
    HECTARES_DOSE_PRICE_DIFFERENCE:
      'Surcoût des semences de la variété haut de gamme',
    INVESTMENT_PER_DAIRY_COW: 'Investissement par vache laitière',
    INVESTMENT_PER_1000_LITERS_MILK: 'Investissement pour 1 000 litres de lait',
    ADDITIONAL_FORAGE_PRODUCTION_TMS: 'Production additionnelle maïs fourrage',
    ADDITIONAL_FORAGE_PRODUCTION_VALUE:
      'Valeur de la production additionnelle maïs fourrage',
    ADDITIONAL_ENERGY_PRODUCTION_UFL: "Production additionnelle d'énergie",
    ADDITIONAL_ENERGY_PRODUCTION_VALUE:
      "Valeur de la production additionnelle d'énergie",
    ADDITIONAL_MILK_PRODUCTION_LITERS:
      'Production additionnelle de lait permise',
    ADDITIONAL_MILK_PRODUCTION_VALUE:
      'Valeur de la production additionnelle de lait permise',

    INVESTMENT_UNIT: '€ pour la surface totale en maïs fourrage',
    FORAGE_AND_MILK_GAINS_UNIT: '€',
    GAIN_PER_DAIRY_COW_PER_YEAR_UNIT: '€/vache/an',
    GAIN_PER_1000_LITERS_MILK_UNIT: '€/1 000 litres de lait produit',
    RETURN_ON_INVESTMENT_UNIT: '€ gagnés pour 1 € supplémentaire investi',

    BUDGET_VARIETY_B_SEEDS_UNIT: '€',
    HECTARES_DOSE_PRICE_DIFFERENCE_UNIT: '€',
    INVESTMENT_PER_DAIRY_COW_UNIT: '€/vache/an',
    INVESTMENT_PER_1000_LITERS_MILK_UNIT: '€/1 000 litres de lait produit',

    ADDITIONAL_FORAGE_PRODUCTION_TMS_UNIT: 'tMS supplémentaires sur la ferme',
    ADDITIONAL_FORAGE_PRODUCTION_VALUE_UNIT: '€',
    ADDITIONAL_ENERGY_PRODUCTION_UFL_UNIT: 'UFL supplémentaires',
    ADDITIONAL_ENERGY_PRODUCTION_VALUE_UNIT: '€',
    ADDITIONAL_MILK_PRODUCTION_LITERS_UNIT:
      "litres de lait supplémentaires permis par l'énergie",
    ADDITIONAL_MILK_PRODUCTION_VALUE_UNIT: '€'
  },
  'en-US': {
    AGRICULTURAL_AREA: 'Agricultural area',
    AREA_TYPE: 'Area type'
  }
};

export default messages;
